document.addEventListener('DOMContentLoaded', function() {
  const sliders = CollectionSliderModule.init('.collection-list', {
    
  });
  
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.classList.contains('collection-list')) {
        CollectionSliderModule.init(event.target);
      }
    });
  }
});